/**
 * Copyright © 2025-2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Navigate, RouteObject, useRoutes } from "react-router-dom";

import { useSetActiveAccount } from "../../features/account/hooks/useSetActiveAccount";
import { paymentsRoutes } from "../../features/account/payments/routes";
import { accountRoutes } from "../../features/account/routes";
import { activitiesRoutes } from "../../features/activities/routes";
import { cardPartnerDirectoryRoutes } from "../../features/card-partner-directory/routes";
import { cardsRoutes } from "../../features/cards/routes";
import { useApplyHomeBranchAsDefaultPickup } from "../../features/cart/hooks/useApplyHomeBranchAsDefaultPickup";
import { ordersRoutes } from "../../features/orders/routes";
import { productsRoutes } from "../../features/products/routes";
import { quotesRoutes } from "../../features/quotes/routes";
import { salesAgreementRoutes } from "../../features/sales-agreements/routes";
import { seedRoutes } from "../../features/seed-orders/routes";
import DeprecatedHome from "../../pages/DeprecatedHome";
import Home from "../../pages/Home";
import { HOME_ANY_ROUTE, HOME_ROUTE, LOGOUT_CE_USER_ROUTE, LOGOUT_ROUTE } from "../../util/routing";

import Logout from "./Logout";
import LogoutCEUser from "./LogoutCEUser";
import { FlagSwitchGate } from "./route-gates";

const AuthenticatedRoutes = () => {
  useApplyHomeBranchAsDefaultPickup();
  useSetActiveAccount();

  const routes: RouteObject[] = [
    {
      path: "/",
      children: [
        { path: LOGOUT_ROUTE, element: <Logout /> },
        { path: LOGOUT_CE_USER_ROUTE, element: <LogoutCEUser /> },
        {
          path: HOME_ANY_ROUTE,
          element: (
            <FlagSwitchGate
              flag="enableHome"
              flagEnabled={<Home />}
              flagDisabled={<DeprecatedHome />}
            />
          ),
        },
        ...productsRoutes,
        ...quotesRoutes,
        ...ordersRoutes,
        ...seedRoutes,
        ...salesAgreementRoutes,
        ...cardsRoutes,
        ...paymentsRoutes,
        ...cardPartnerDirectoryRoutes,
        ...accountRoutes,
        ...activitiesRoutes,
        { path: "/", element: <Navigate to={HOME_ROUTE} /> },
        { path: "/login", element: <Navigate to={HOME_ROUTE} /> },
        { path: "/newhome", element: <Home /> },
      ],
    },
    { path: "", element: <Navigate to={HOME_ROUTE} /> },
    { path: "*", element: <Navigate to={HOME_ROUTE} /> },
  ];

  return useRoutes(routes);
};

export default AuthenticatedRoutes;
